import type { ProductInputSource } from 'typings/graphql'


type GetProductInputSourceProps = {
  theEdit?: boolean
  theShop?: boolean
}

const getProductInputSource = ({ theEdit, theShop }: GetProductInputSourceProps): ProductInputSource => {
  if (theEdit) {
    return 'THE_EDIT'
  }

  if (theShop) {
    return 'THE_SHOP'
  }

  return null
}

export default getProductInputSource
